import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-incassi-list',
  templateUrl: './incassi-list.component.html',
  styleUrls: ['./incassi-list.component.css']
})
export class IncassiListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/incassi/incassi-list.component.ts